import { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { ListRow, WithTooltip } from 'basic-components';
import { QuestionMark } from 'basic-components/icons';

import classNames from 'classnames';
import './InfoRow.scss';

const WHOLE_ROW_TOOLTIP_EXTRA_STYLE = { top: -16 }
const TOOLTIP_EXTRA_STYLE = { left: 40 }
const CONTACT_MESSAGE = "Contact support@northgravity.com to get access to this symbol"
const InfoRow = ({ symbol, symbolIndex }) => {
  const [isOverflowed, setIsOverflowed] = useState(false),
        taskPaneWidth = useSelector(state => state.globalState.taskPaneWidth),
        timeoutRef = useRef(),
        ref = useRef(),
        contentProps = useMemo(() => ({ ref }), [])

  useEffect(() => {
    if(ref.current) {
      setIsOverflowed(ref.current.scrollWidth > ref.current.clientWidth)
    } else {
      clearTimeout(timeoutRef.current)
      timeoutRef.current = setTimeout(() => setIsOverflowed(ref.current.scrollWidth > ref.current.clientWidth), 5)
    }
  }, [taskPaneWidth])

  useEffect(() => () => {
    clearTimeout(timeoutRef.current)
  }, [])

  return (
    <ListRow
        beforeChildren={(
            <WithTooltip
                data-place="right"
                extraStyle={WHOLE_ROW_TOOLTIP_EXTRA_STYLE} // adjusted to fit into smallest possible side pane size
                key={symbolIndex}
                text={CONTACT_MESSAGE}
            >
              <div
                  aria-label="Info icon"
                  className="ng-office-app__authed__content__starting__block__content__info-row__info-icon"
              >
                <QuestionMark color="grey-medium"/>
              </div>
            </WithTooltip>
        )}
        className={classNames(
          "ng-office-app__authed__content__starting__block__content__info-row",
          { "ng-office-app__authed__content__starting__block__content__info-row--is-overflowed": isOverflowed },
        )}
        contentProps={contentProps}
        height={44}
        offset={8000}
        unmountIfInvisible={false}
    >
      <WithTooltip
          data-place="top"
          extraStyle={TOOLTIP_EXTRA_STYLE} // adjusted to fit into smallest possible side pane size
          text={CONTACT_MESSAGE}
      >
        <div className="ng-office-app__authed__content__starting__block__content__info-row__content">
          <div
              className="ng-office-app__authed__content__starting__block__content__info-row__cell"
          >
            {symbol.symbols[symbol.mainSymbolKey]}
          </div>
          {(symbol.displayFields || []).map(field => (
            <div
                className={classNames(
                  "ng-office-app__authed__content__starting__block__content__info-row__cell",
                  { "ng-office-app__authed__content__starting__block__content__info-row__cell--is-overflowed": isOverflowed }
                )}
                key={`${field.source} + ${field.key} + ${symbolIndex}`}
            >
              <div className="ng-office-app__authed__content__starting__block__content__info-row__cell__label">{field.key}:</div>
              <div className="ng-office-app__authed__content__starting__block__content__info-row__cell__value">{symbol[field.source][field.key]}</div>
            </div>
          ))}
        </div>
      </WithTooltip>
    </ListRow>
  )
}

InfoRow.propTypes = {
  symbol: PropTypes.object.isRequired,
  symbolIndex: PropTypes.number.isRequired
}

export default InfoRow;